/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit No/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import HappyToothGraphic from 'DesignSystem/Svgs/HappyToothGraphic/index'
import Info from 'DesignSystem/Info/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function No({
  children,
  viewPath = "/App/Auth/SignUp/Instructions/No"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="No.Vertical"
  data-view-path={viewPath}
 style={{'--mr-1-Fs': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<HappyToothGraphic
  viewPath={`${viewPath}/HappyToothGraphic`}
 width={80}
 height={80}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 text="Practice Hub"
/>
</div>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 text="Sign up"
/>
<Info
  viewPath={`${viewPath}/Info`}
 size="medium"
 marginTop={dtSpaceS}
 textOverflow="none"
 whiteSpace="wrap"
 text="Use the email address you provided to the clinic"
/>
{children}
</React.Fragment>)
}